module.exports = __webpack_public_path__ + "img/BAU Seniors_Infographics_63.7c75dd69.png";